import { Control, Controller, FieldValues, RegisterOptions, FieldPath } from 'react-hook-form';
import { AppTimePickerField, AppTimePickerFieldProps } from '../fields/time/timePicker';

type HookFormTimePickerFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<AppTimePickerFieldProps, 'onTimeChanged' | 'timeInMills'> & {
  name: TName;
  control: Control<TFieldValues>;
  rules?: Exclude<RegisterOptions, 'valueAsDate' | 'setValueAs'>;
  onFocus?: () => void;
  defaultValue?: unknown;
};

/*
We have to use Controlled components for native html datepickers,
because they require values in a form of 'yyyy-MM-DD', but in uncontrolled form react-hook-form
supply them with Date object.
 */
export function HookFormTimePickerField(props: HookFormTimePickerFieldProps) {
  return (
    <Controller
      control={props.control}
      name={props.name}
      rules={props.rules}
      defaultValue={props.defaultValue}
      render={({ field, formState: { isSubmitting }, fieldState: { error } }) => (
        <div tabIndex={0} ref={field.ref}>
          <AppTimePickerField
            timeInMills={field.value}
            onTimeChanged={field.onChange}
            {...props}
            disabled={props.disabled || isSubmitting}
            errorProps={{
              ...props.errorProps,
              errors: error?.message ?? props.errorProps?.errors,
            }}
          />
        </div>
      )}
    />
  );
}
